import React, { Component } from "react";
import { NavLink, Link } from "react-router-dom";
import logodashheader from "../Assets/logo-dash-header.png";
import FeedBackImg from "../Assets/ratings-review.png";
import Footer from "../Components/footer";
import Header from "../Components/header";
import SideBar from "../Components/sidebar";
import Button from "../Components/button";
import DataTable from "../Components/datatablereview";
import {
  DateTime,
  RedirectNotLogin,
  RedirectContractor,
  getSession,
  UpdateState,
  getState,
  handleSubmit,
  BreedForm,
  AlertMessage,
  AlertMessageOut,
  serializeArray,
} from "../Components/function";

class Review extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userID: "",
      scriptID: "",
      file: "",
      message: "",
    };
  }

  componentDidMount() {
    RedirectNotLogin();
    RedirectContractor();
  }

  componentDidUpdate() {
    RedirectNotLogin();
    RedirectContractor();
  }

  render() {
    return (
      <div className="App AppWrap">
        <Header self={this} />

        <div className="App iBG dash-dash-full">
          <div className="containers">
            <div className="card-lt-wrap">
              <div className="card-lt breadcrumb view-editor-wrap">
                <div>
                  <h1>
                    <NavLink to="/dashboard">Dashboard</NavLink>{" "}
                    <i className="fa fa-chevron-right"></i>{" "}
                    <NavLink to="/review">Review</NavLink>{" "}
                    <i className="fa fa-chevron-right"></i>{" "}
                    {getSession("division")}
                  </h1>
                </div>
                <div style={{ textAlign: "right" }}>
                  <NavLink to="/editors">
                    <button
                      className="btn chip primaryX white"
                      style={{ padding: "13px 20px", fontSize: "12.5px" }}
                    >
                      <i className="fa fa-eye"></i> View Editors
                    </button>
                  </NavLink>
                </div>
              </div>
            </div>

            <div className="card-lt-wrap">
              <div className="card-lt">
                {AlertMessageOut(this)}

                <DataTable
                  route="review"
                  badge={["", "", "", "", "", "", ""]}
                  thclassX={[
                    "",
                    "",
                    "center",
                    "",
                    "nowrap",
                    "nowrap",
                    "nowrap",
                    "",
                  ]}
                  th={[
                    "Script ID",
                    "Geo Target",
                    "Open Status",
                    "Summary",
                    "Review 1",
                    "Review 2",
                    "Review 3",
                    "Note",
                  ]}
                  td={[
                    "scriptID",
                    "target",
                    "commit_status",
                    "summary",
                    "cmd1",
                    "cmd2",
                    "cmd3",
                    "note",
                  ]}
                  cmd="review"
                  self={this}
                />
              </div>

              <Footer classX="dash-footer" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Review;
